import { Role } from "@/vue/types/role";
import { createEntityStore } from "@/vue/store/createEntityStore";

export const useRoleStore = createEntityStore<Role>("role", "/api/support/role");